export const ALL_TODO = 'ALL_TODO';
export const ACTIVE_TODO = 'ACTIVE_TODO';
export const COMPLETED_TODO = 'COMPLETED_TODO';
